<template>
  <div class="Registers">
    <div class="carroselCtn">
      <div class="StatementOnAccount">
        <label
          v-for="item in tabs"
          :key="item.text"
          class="StatementOnAccountItem"
          :class="{ active: selectedTabLabel === item.value }"
          @click="storeLabelTabName(item.text)"
        >
          {{ item.text }} <br />
        </label>
      </div>
    </div>
    <div v-if="selectedTabLabel === 'Clientes'" class="generalTableItem">
      <CustomerTable />
    </div>
    <div v-if="selectedTabLabel === 'Produtos'" class="generalTableItem">
      <ProductsTable />
    </div>
    <div v-if="selectedTabLabel === 'Fornecedores'" class="generalTableItem">
      <SupplierTable @supplierLenght="supplierLenght = $event" />
    </div>
    <div v-if="selectedTabLabel === 'Funcionários'" class="generalTableItem">
      <EmployeeTable />
    </div>
    <div v-if="selectedTabLabel === 'Aplicadores'" class="generalTableItem">
      <ApplicatorTable />
    </div>

    <div :class="sizeModalRegister">
      <div :class="modalContainer" v-if="colapseRegister">
        <b-button class="closeModalRegister" @click="modalHeight"> X </b-button>
        <Customer class="cardContentModal" v-if="this.typeRegister.customer" />
        <Employee class="cardContentModal" v-if="this.typeRegister.employee" />
        <Applicator class="cardContentModal" v-if="this.typeRegister.applicator" />
        <Products class="cardContentModal" v-if="this.typeRegister.products" />
        <Supplier class="cardContentModal" v-if="this.typeRegister.supplier" />
      </div>
    </div>
  </div>
</template>
<script>
import Customer from "../Customer/Customer.vue";
import Employee from "../Employee/Employee.vue";
import Applicator from "../Applicator/Applicator.vue";
import Products from "../Products/Products.vue";
import Supplier from "../Supplier/Supplier.vue";
import CustomerTable from "./CustomerTable.vue";
import ProductsTable from "./ProductsTable.vue";
import SupplierTable from "./SupplierTable.vue";
import EmployeeTable from "./EmployeeTable.vue";
import ApplicatorTable from "./ApplicatorTable.vue";

import { mapMutations, mapState } from "vuex";
import serviceRegisters from "../../services/serviceRegisters";

export default {
  components: {
    Customer,
    Employee,
    Applicator,
    Products,
    Supplier,
    CustomerTable,
    ProductsTable,
    SupplierTable,
    EmployeeTable,
    ApplicatorTable,
  },
  data() {
    return {
      counter: {},
      tableActive: {
        customer: true,
        supplier: false,
        employee: false,
        products: false,
      },
      supplierLenght: 0,
      selectedTabLabel: "Clientes",
      tabs: [
        { value: "Clientes", text: "Clientes" },
        { value: "Fornecedores", text: "Fornecedores" },
        { value: "Produtos", text: "Produtos" },
        { value: "Funcionários", text: "Funcionários" },
        { value: "Aplicadores", text: "Aplicadores" },
      ],
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_CUSTOMER",
      "SET_DATA_SEARCH_FROM_EMPLOYEE",
      "SET_DATA_SEARCH_FROM_APPLICATOR",
      "SET_DATA_SEARCH_FROM_PRODUCT",
      "SET_DATA_SEARCH_FROM_SUPPLIER",
    ]),

    async activeTable(event) {
      const button = event.currentTarget;
      const name = button.name;
      this.tableActive = {
        customer: false,
        supplier: false,
        employee: false,
        products: false,
        [name]: true,
      };
    },
    storeLabelTabName(labelName) {
      this.selectedTabLabel = labelName;
    },
    async countAll() {
      try {
        this.counter = await serviceRegisters.countAll();
      } catch (error) {
        console.log(error.response);
      }
    },

    async modalHeight() {
      this.SET_COLAPSE_REGISTER(!this.colapseRegister);
      this.colapseRegister
        ? this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral")
        : this.ALTER_SIZE_MODAL_REGISTER("disable");
      this.modalContainer
        ? this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer")
        : this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");

      if (!this.colapseRegister && this.sizeModalRegister === "disable") {
        this.SET_DATA_SEARCH_FROM_CUSTOMER({});
        this.SET_DATA_SEARCH_FROM_EMPLOYEE({});
        this.SET_DATA_SEARCH_FROM_APPLICATOR({});
        this.SET_DATA_SEARCH_FROM_PRODUCT({});
        this.SET_DATA_SEARCH_FROM_SUPPLIER({});
      }
      this.countAll();
    },

    async handleModals(event) {
      const name = event.target.name;
      this.ALTER_TYPE_REGISTER(name);

      this.modalHeight();
    },
  },
  computed: {
    ...mapState({
      sizeModalRegister: (state) => state.sizeModalRegister,
      typeRegister: (state) => state.typeRegister,
      colapseRegister: (state) => state.colapseRegister,
      modalContainer: (state) => state.modalContainer,
    }),
  },
  created() {
    this.SET_COLAPSE_REGISTER(false);
    this.SET_DATA_SEARCH_FROM_CUSTOMER({});
    this.SET_DATA_SEARCH_FROM_EMPLOYEE({});
    this.SET_DATA_SEARCH_FROM_APPLICATOR({});
    this.SET_DATA_SEARCH_FROM_PRODUCT({});
    this.SET_DATA_SEARCH_FROM_SUPPLIER({});
    this.ALTER_SIZE_MODAL_REGISTER("disable");
    this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");
    this.countAll();
  },
};
</script>
<style scoped>
.Registers {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 13px;
  position: relative;
}

.carroselCtn {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-top: 61px;
  width: 100%;
  height: 45px;
  background: #ffffff;
  border-radius: 3px;
}

.StatementOnAccount {
  display: flex;
  align-items: center;
  height: 35px;
  width: 100%;
  gap: 10px;
}
.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  padding: 0 10px;
  color: #006458;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  color: #006458;
  border-bottom: 3px solid #006458;
}

.StatementOnAccountItem:hover {
  background-color: #eaeaea;
  color: #006458;
}

.StatementOnAccountItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.titleGeneralRegisters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
}

.generalTableItem {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  margin-top: 5px;
  margin-bottom: 30px;
  border-radius: 8px;
  background: #ffffff;
  max-height: calc(100vh - 80px);
  overflow: hidden;
}

.BtnRegister {
  position: absolute;
  width: 200px;
  right: 30px;
  top: 61px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  color: #006458;
}

.BtnRegister:hover {
  background: whitesmoke;
  box-shadow: none;
}

.SumRegisters {
  display: flex;
  height: 90px;
  width: 100%;
  margin-top: 70px;
  justify-content: space-evenly;
  align-items: center;
}

.ItemSumRegisters {
  width: 23%;
  height: 60px;
  border-radius: 5px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.ItemSumRegisters:hover {
  background: rgba(245, 245, 245, 0.546);
}
.ItemSumRegisters:focus {
  background: rgba(245, 245, 245, 0.764);
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.cardContentModal {
  width: 85vw;
  margin-top: 20px;
  margin-left: 5vw;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalRegister:hover {
  background: whitesmoke;
  color: red;
}

.closeModalRegister:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.titleCountRegisters {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .titleCountRegisters {
    font-size: 10px;
  }
  .ItemSumRegisters {
    gap: 0px;
    width: 19%;
    justify-content: space-between;
  }
  .Registers {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
  .BtnRegister {
    width: 19%;
    font-size: 10px;
    height: 25px;
  }
  .SumRegisters {
    height: 74px;
  }
}

@media screen and (max-width: 700px) {
  .cardContentModal {
    width: 100%;
    margin-top: 30px;
    margin-left: 0vw;
  }

  .Registers {
    margin-left: 0px;
    width: 100%;
    height: 100vh;
    font-size: 11px;
  }

  .SumRegisters {
    margin: 55px 0 10px 0;
  }

  .ItemSumRegisters {
    width: 19%;
    height: 70px;
    gap: 0px;
    font-size: 10px;
  }

  .BtnRegister {
    width: 19%;
    height: 60px;
    font-size: 11px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .ModalGeneral {
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }
}
</style>
